import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

import type { Banner } from "@shared/types/Banner";

interface BannerEntityParams {
  image_url: string;
  forward_url: string;
  slot_id: string;
  width: number;
  height: number;
}
export class BannerEntity extends BaseEntityClass {
  image_url: string;
  forward_url: string;
  slot_id: string;
  width: number;
  height: number;
  constructor(params: BannerEntityParams) {
    super();
    this.type = "banner";
    this.entity_version = 2;
    this.image_url = params.image_url;
    this.forward_url = params.forward_url;
    this.slot_id = params.slot_id;
    this.width = params.width;
    this.height = params.height;
  }

  static fromBanner(banner: Banner): BannerEntity {
    return new BannerEntity({
      image_url: banner.image_url,
      forward_url: banner.forward_url,
      slot_id: banner.slot_id,
      width: banner.width,
      height: banner.height,
    });
  }
}
